<script>
import SideDrawer from "../package/sideDrawer.vue";
import TopImageSection from "../package/topImageSection.vue";
import SearchSection from "../package/searchSection.vue";
import BuyOffPlanSection from "../package/buyOffPlanSection.vue";
import FooterSection from "../package/footerSection.vue";
import DrawerAside from "../package/DrawerAside.vue";
import agentSignInSection from "../package/agentSignInSection.vue";
import propertyIconSet from "../package/propertyIconSet.vue";
import discoverMore from "../package/discoverMore.vue";
import SocialSection from "../package/socialSection.vue";
import AdvertisementThree from "../package/advertisementThree.vue";
import AgentsRegistration from "../package/agentsRegistration.vue";
import AdvertisementTwo from "../package/advertisementTwo.vue";
import AdvertisementOne from "../package/advertisementOne.vue";
import ContactUs from "../package/contactUs.vue";
import ConnectingProperties from "../package/connectingProperties.vue";
import StayUpToDate from "../package/stayUpToDate.vue";
import FindOutMore from "../package/findOutMore.vue";
import HeaderSection from "../package/HeaderSection.vue";
import { mapActions } from "vuex";
import NewPropertiesSection from "../package/newPropertiesSection.vue";
import EmailUsSectionLight from "../contact/emailUsSectionLight.vue";
// import MobileAppDownload from "../package/mobileAppDownload.vue";
import BlogWidgetView from "../blog/blogWidgetView/blogWidgetLayout.vue";
import RequestToJoinUConnectCorporateDialog from "../common/requestToJoinUConnectCorporateDialog.vue";

export default {
  name: "MainLayoutInterim",
  data() {
    return {
      adPage: "Home Page Creative Ads",
      adSuburbs: "",
      adsData: "",
      drawer: false,
      unfold: false,
      visible: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D",
      bannerImages: [
        require('../../assets/main-banner.png')
      ],
      currentImageIndex: 0,
      requestToJoinDialogVisible: false,
    };
  },
  components: {
    RequestToJoinUConnectCorporateDialog,
    BlogWidgetView,
    NewPropertiesSection,
    HeaderSection,
    FindOutMore,
    StayUpToDate,
    ConnectingProperties,
    ContactUs,
    AdvertisementOne,
    AdvertisementTwo,
    AgentsRegistration,
    AdvertisementThree,
    SocialSection,
    DrawerAside,
    FooterSection,
    BuyOffPlanSection,
    SearchSection,
    TopImageSection,
    SideDrawer,
    discoverMore,
    propertyIconSet,
    agentSignInSection,
    EmailUsSectionLight,
    // MobileAppDownload
  },
  computed: {
    currentBannerImage() {
      console.log("startImageRotation", this.currentImageIndex);
      return this.bannerImages[this.currentImageIndex];
    },
  },
  beforeUpdate() {
    document.title = "UNIFI Property: Home";
  },
  methods: {
    ...mapActions("home", ["getAds"]),
    ...mapActions('common', ['getAllHomeBannerImageList']),
    getAllHomeBannerImages() {
      this.getAllHomeBannerImageList({ params: {}, callback: this.callbackGetAllHomeBannerImageList });
    },
    callbackGetAllHomeBannerImageList(res) {
      console.log("callbackGetAllHomeBannerImageList", res);
      if (res.code === 0 ) {

        console.log(res.data);
        this.bannerImages = res.data;
      }
    },
    startImageRotation() {
      setInterval(() => {

        this.currentImageIndex =
          (this.currentImageIndex + 1) % this.bannerImages.length;
      }, 15000); // Change image every 5 seconds

    },
    spread() {
      this.unfold = true;
      console.log("this.unfold = true");
    },
    fold() {
      this.unfold = false;
      console.log("this.unfold = false");
    },
    getAdsbyPageAndSuburb() {
      let body_params = {
        adPage: this.adPage,
        adSuburbs: this.adSuburbs
      };
      this.getAds({
        params: { other: body_params },
        callback: this.callbackAd
      });
    },
    callbackAd(resp) {
      if (resp.data.code == 0) {
        this.adsData = resp.data.data;
      } else {
      }
      console.log("this.adsData", this.adsData);
    },
    redirectToB2B() {
      this.$router.push("/pricing");
    },
    contactUs() {
      this.requestToJoinDialogVisible = true;
    },
    redirectToDeveloperAgent() {
      this.$router.push("/agents");
    },
  },
  created() {
    var that = this;
    that.getAllHomeBannerImages();
  },
  mounted() {
    this.startImageRotation();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
    this.getAdsbyPageAndSuburb();

  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  }
};
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible; background: radial-gradient(circle at bottom right, #003030 70%, #121312 100%);">

        <el-row>
          <!--      -->
          <el-col :span="24">
            <el-row>
              <el-col :span="24">
                <el-row >
                  <el-col :span="21" :offset="3" style="display: flex; justify-content: center; padding:5%">
                    <h1 class="main-title">Help your clients stay ahead with access to off-the-plan properties
                    </h1>
                  </el-col>
                </el-row>
                <el-row >
                  <el-col :span="21" offset="3" style="display: flex; justify-content: center">
                    <div class="action-buttons" style="width: 100%;">
                      <el-button plain class="login-action-btn" @click="redirectToB2B">Start Now</el-button>
                      <el-button type="primary" class="contact-up-btn" @click="contactUs">Contact Us</el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="24">
                <el-row style="padding: 2%;">
                  <div class="banner-container">
                    <img
                      class="banner-image"
                      loading="lazy"
                      :src="currentBannerImage"
                      alt="banner"
                    />
                  </div>
                </el-row>

              </el-col>
            </el-row>
          </el-col>
          <!--        -->
          <el-col :span="24" style="background-color: #ffffff;">
            <el-row>
              <el-col :span="24">
                <h1 style="color: #003333; font-size: 20px; padding: 10% 20% 0;">Do you want to list your projects?</h1>
              </el-col>
              <el-col :span="24" class="register-section-wrapper">
                <div class="register-section">
                  <div class="promo-item">
                    <h3>Developer ?</h3>
                    <p>Want to know more?</p>
                    <el-button type="primary" class="contact-sales-btn green-btn" @click="redirectToDeveloperAgent">Register</el-button>
                  </div>
                </div>
              </el-col>
              <el-col :span="24"  class="register-section-wrapper">
                <div class="register-section">
                  <div class="promo-item">
                    <h3>Real Estate Agent ?</h3>
                    <p>Want to know more?</p>
                    <el-button type="primary" class="contact-sales-btn green-btn" @click="redirectToDeveloperAgent">Register</el-button>
                  </div>
                </div>
              </el-col>


            </el-row>
          </el-col>
        </el-row>
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
    <request-to-join-u-connect-corporate-dialog v-if="requestToJoinDialogVisible"
                                                :request-to-join-dialog-visible="requestToJoinDialogVisible"
                                                @onClose="requestToJoinDialogVisible = false"/>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #2d2d2d;
}

.el-switch /deep/ .el-switch__label--left {
  color: #ffffff;
  //color: #2D2D2D;
}

.el-switch /deep/ .el-switch__label--right {
  color: #ffffff;
}

.el-switch /deep/ .el-switch__core:after {
  background-color: var(--switch-color);
}
.main-title {
  color: #ffffff;
  font-size: 40px;
}
.banner-container {
  flex-direction: column;
  overflow: hidden;
  align-self: center;
  position: relative;
  display: flex;
  min-height: 300px;
  max-height: 300px;
  max-width: 100%;
  justify-content: center;
  align-items: center;
  margin: auto;
  background-color: #0d0d0d;
}

.banner-image {
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: fill;
  object-position: top;
}

.register-section-wrapper {
  padding: 5% 0;
}
.register-section {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.login-action-btn {
  border-color: #ffffff;
  color: #003333;
}

.login-action-btn:hover, .login-action-btn:focus {
  background-color: #003333;
  color: #ffffff;
  border-color: #ffffff;
}

.login-action-btn /deep/ .is-active {
  color: #ffffff;
  border-bottom-color: #ffffff;
}

.contact-sales-btn {
  background-color: #ffffff;
  border-color: #ffffff;
  color: #003333;
}

.contact-sales-btn:hover, .contact-sales-btn:focus {
  background-color: #003333;
  color: #ffffff;
  border-color: #ffffff;
}
.contact-up-btn {
  background-color: #003333;
  color: #ffffff;
  border-color: #ffffff;
}

.contact-up-btn:hover, .contact-up-btn:focus {
  background-color: #ffffff;
  border-color: #ffffff;
  color: #003333;
}
.green-btn {
  background-color: #003333;
  color: #ffffff;
  border-color: #003333;
}

.green-btn:hover, .green-btn:focus {
  background-color: #ffffff;
  border-color: #003333;
  color: #003333;
}

@media only screen and (min-width: 320px)  {
  .main-title {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/mainLayout-Interim.vue